import { FT_PI_BB_CONTROLS_MOBILE_DISPLAY } from '@whitbread-eos/api';
import useFeatureToggle from './use-feature-toggle';
import { useScreenSize } from './use-screensize';
var CHANNELS_LIST = new Set(['pi', 'bb']);
export default function useMobileControlsDisplay(channel) {
  var _useScreenSize = useScreenSize(),
    isLessThanSm = _useScreenSize.isLessThanSm,
    isLessThanMd = _useScreenSize.isLessThanMd;
  var featureToggles = useFeatureToggle();
  var isMobileDisplayEnabled = featureToggles[FT_PI_BB_CONTROLS_MOBILE_DISPLAY];
  if (!channel) return false;
  var normalizedChannel = channel.toLowerCase();
  var isValidChannel = CHANNELS_LIST.has(normalizedChannel);
  var isMobileScreen = isLessThanSm || isLessThanMd;
  return isMobileDisplayEnabled && isValidChannel && isMobileScreen;
}